import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const AMLFraudChecksRefName = 'aml-fraud-checks';

export default function AMLSection() {
  const { checklist } = useChecklistContext();

  const { fraudChecks } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={AMLFraudChecksRefName}
      section={ChecklistSection.AML_FRAUD}
      subSection={ChecklistSection.NOTES_AML}
      checklistItem={fraudChecks}
    >
      <PaddedGenericSection
        subSection={ChecklistSection.AML_EQUIFAX}
        level={2}
      >
        <PaddedGenericSection
          subSection={ChecklistSection.VERIFICATION_HEADER}
          level={2}
        >
          <p>level 2</p>
        </PaddedGenericSection>
      </PaddedGenericSection>
    </PaddedGenericSection>
  );
}
